// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { createContext, useContext, useEffect, useState } from "react";
import { Howler } from "howler";

const MuteContext = createContext(
  {} as {
    isMuted: boolean;
    toggleMute: () => void;
  },
);

export const useMute = () => useContext(MuteContext);

export const AudioProvider = ({ children }: any) => {
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    console.log("AudioProvider mounted, isMuted:", isMuted);
    muteOrUnmuteSite(isMuted); // Mute or unmute the site based on the state
  }, [isMuted]);

  const muteOrUnmuteSite = (mute: boolean) => {
    // Mute or unmute all audio and video elements
    const mediaElements = document.querySelectorAll("audio, video");
    mediaElements.forEach((element) => {
      console.log(`${mute ? "Muting" : "Unmuting"}:`, element);
      (element as HTMLMediaElement).muted = mute;
    });

    Howler.mute(mute);

    // Mute or unmute all iframes using a postMessage (if supported by the iframe content)
    const iframes = document.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
      try {
        if (!iframe.contentWindow) return;
        iframe.contentWindow.postMessage(
          { type: mute ? "mute" : "unmute" },
          "*",
        );
      } catch (error) {
        console.error("Failed to send mute/unmute message to iframe:", error);
      }
    });

    // Injecting CSS to stop audio from embedded games, videos, etc.
    if (mute) {
      const style = document.createElement("style");
      style.id = "mute-style";
      style.innerHTML = `
        audio, video {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    } else {
      const style = document.getElementById("mute-style");
      if (style) {
        document.head.removeChild(style);
      }
    }

    // Attempt to access and mute audio using PixiJS or similar (if accessible)
    iframes.forEach((iframe) => {
      try {
        if (!iframe.contentDocument || !iframe.contentWindow) return;

        const iframeDoc =
          iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDoc && iframe.contentWindow.PIXI) {
          // Access PixiJS Application from the iframe's window context
          const pixiApp = iframe.contentWindow.PIXI.Application;
          if (pixiApp && pixiApp.prototype) {
            const appInstance = Object.values(pixiApp.prototype).find(
              (app: any) => app.stage,
            );
            if (appInstance && appInstance.stage) {
              appInstance.stage.children.forEach((child: any) => {
                if (child.sound) {
                  child.sound.volume = mute ? 0 : 1; // Mute all sound-producing children
                }
              });
            }
          }
        }
      } catch (error) {
        console.error("Failed to access or mute PixiJS in iframe:", error);
      }
    });
  };

  const toggleMute = () => {
    setIsMuted((prev) => !prev);
  };

  return (
    <MuteContext.Provider value={{ isMuted, toggleMute }}>
      {children}
    </MuteContext.Provider>
  );
};

export default AudioProvider;
